export default "__VITE_ASSET__C5zxRdig__"